// extracted by mini-css-extract-plugin
export default {"variantsWrapper":"EcvNI","variant":"XfrF6"};